import { trackInteraction } from 'client/javascript/analytics';

export function trackFilterClick(filter) {
  const props = {
    label: `${getPageNameFromHtmlTag()} Open Filter`,
    filterName: filter.text
  };

  trackInteraction(props);
}

export function trackFilterApplyClick(filter) {
  const props = {
    label: `${getPageNameFromHtmlTag()} Apply Filter`,
    filterName: filter.text,
    filterValue: filter.value
  };

  trackInteraction(props);
}

export function trackFilterClearClick(filter) {
  const props = {
    label: `${getPageNameFromHtmlTag()} Clear Filter`,
    filterName: filter.text
  };

  trackInteraction(props);
}

function getPageNameFromHtmlTag() {
  const htmlClassList = Array.from(document.querySelector('html').classList);
  const pageNameClass = htmlClassList.filter(className => className.startsWith('page-'))[0];

  if (!pageNameClass) return '';

  const pageName = pageNameClass.split('-')[1];
  const capitalizedPageName = pageName.charAt(0).toUpperCase() + pageName.slice(1);

  return `${capitalizedPageName} Page`;
}
